import { useContext } from "react";

import { AppContext } from "contexts/AppContext";

const useLocale = (): { locale: null | string } => ({ locale: useContext(AppContext).locale });

export default useLocale;
